<template src="./templates/index.html" />

<script type="text/ecmascript-6">
import Misc from 'src/utils/helper/misc'
import { mapActions, mapGetters } from 'vuex'
import AnimationProcessing from 'components/animations/processing'
import { adobeCjaEventEmitter } from 'modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_CATEGORIES, LINK_NAMES, LINK_TYPES } from 'modules/adobe-cja/constants'
export default {
  name: 'ApplicationStatus',

  components: {
    AnimationProcessing
  },

  data () {
    return {
    }
  },

  methods: {
    ...mapActions('signUp', ['getApplicationByUserID']),
    ...Misc,
    reapply (status) {
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.APPLICATION_ALREADY_IN_PROGRESS,
          linkSection: window?.pageInfoGlobal?.pageInfo?.pageSection || '',
          linkName: LINK_NAMES.GET_STARTED,
          linkType: LINK_TYPES.ICON
        }
      })
      this.$store.commit('auth/setApplicationStatus', status)
      window.localStorage.setItem('application_status', status)
      this.$router.push({ path: '/get-started' })
    },
    routeToHome (status) {
      if (status === 'exists') {
        this.$store.commit('auth/setUserRole')
        this.$router.replace({ name: 'home' })
      }
    }
  },
  computed: {
    ...mapGetters('signUp', {
      spinner: ['applicationLoader'],
      info: ['applicationDetails']
    }),
    userId: {
      get () {
        return this.$store.getters['auth/user'].userId === '' ? 'na' : this.$store.getters['auth/user'].userId
      }
    },
    getStatusText () {
      const statusLabel = {
        prohibited: this.$t('pages.foundry_application_status.prohibited'),
        rejected: this.$t('pages.foundry_application_status.rejected'),
        in_review: this.$t('pages.foundry_application_status.in_review'),
        approved: this.$t('pages.foundry_application_status.approved')
      }
      return statusLabel[this.info.applicationStatus]
    },
    getStatusDescription () {
      const statusDescription = {
        rejected: this.$t('pages.foundry_application_status.rejected_description'),
        in_review: this.$t('pages.foundry_application_status.in_review_description'),
        approved: this.$t('pages.foundry_application_status.approved_description')
      }
      if (this.info.applicationStatus === 'prohibited') {
        return this.info.message.description
      }
      return statusDescription[this.info.applicationStatus]
    },
    getNotesFromReviewer () {
      if (this.getAppStatusRejected) {
        return this.info.message.description
      }
      return null
    },
    getAppStatusRejected () {
      return this.info.applicationStatus === 'rejected'
    },
    getAppStatusInReview () {
      return ['in_review', 'approved'].includes(this.info.applicationStatus)
    },
    isNewApplicationResume () {
      const applicationStatusFromLocalStorage = window.localStorage.getItem('application_status')
      if (applicationStatusFromLocalStorage !== null && applicationStatusFromLocalStorage !== undefined && String(applicationStatusFromLocalStorage).length > 0) {
        return applicationStatusFromLocalStorage === 'new'
      }
      return this.$store.getters['auth/user'].applicationStatus === 'new'
    }
  },
  created () {
    if (this.isNewApplicationResume) {
      return
    }
    this.getApplicationByUserID(this.userId).then(data => {
      this.routeToHome(data.applicationStatus)
    })
  },
  beforeUnmount () {}
}
</script>

<style src="./stylesheets/index.scss" lang="scss" module></style>
